/**
 * ReceiptIcon — sanitized from `assets/newSvg/receipt.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ReceiptIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M16,3 C17.597725,3 18.903664,4.24892392 18.9949075,5.82372764 L19,6 L19,16 L19.75,16 C20.39725,16 20.9295391,16.4918359 20.9935469,17.1221875 L21,17.25 L21,19 C21,20.597725 19.7511226,21.903664 18.1762773,21.9949075 L18,22 L8,22 C6.40232321,22 5.09633941,20.7511226 5.00509271,19.1762773 L5,19 L5,9 L3.25,9 C2.6027875,9 2.07046563,8.50812891 2.00645356,7.87780591 L2,7.75 L2,6 C2,4.40232321 3.24892392,3.09633941 4.82372764,3.00509271 L5,3 L16,3 Z M19,18 L10.0001,18 L10.0001,19 C10.0001,19.3506 9.9399,19.6872 9.82935,20 L18,20 C18.5523,20 19,19.5523 19,19 L19,18 Z M12,12 L10,12 C9.44772,12 9,12.4477 9,13 C9,13.51285 9.38604429,13.9355092 9.88337975,13.9932725 L10,14 L12,14 C12.5523,14 13,13.5523 13,13 C13,12.48715 12.613973,12.0644908 12.1166239,12.0067275 L12,12 Z M14,8 L10,8 C9.44772,8 9,8.44772 9,9 C9,9.55228 9.44772,10 10,10 L14,10 C14.5523,10 15,9.55228 15,9 C15,8.44772 14.5523,8 14,8 Z M5,5 C4.44772,5 4,5.44772 4,6 L4,7 L5,7 L5,5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ReceiptIcon;
